if (typeof CartAPI === 'undefined') {
  CartAPI = {};
}

CartAPI.addItem = function (url, id, callback, errorCallback) {
  var data = {};
  data.id = id;
  data.quantity = 1;

  var $body = $(document.body),
    params = {
      type: 'POST',
      url: url,
      data: data,
      dataType: 'json',
      beforeSend: function (jqxhr, settings) {
        // $body.trigger('beforeAddItem.ajaxCart', form);
      },
      success: function (line_item) {
        if (typeof callback === 'function') {
          callback(line_item);
        } else {
          // ShopifyAPI.onItemAdded(line_item);
        }
        $body.trigger('afterAddItem.ajaxCart', [line_item]);
      },
      error: function (XMLHttpRequest, textStatus) {
        if (typeof errorCallback === 'function') {
          errorCallback(XMLHttpRequest, textStatus);
        } else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
        $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
      },
      complete: function (jqxhr, text) {
        ShopifyAPI.cartContent.loaded = false
        $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

var ajaxCartGwp = (function (module, $) {
  var init, loadProducts;

  var settings, isUpdating;

  var buildCollection, formOverride, itemAddedCallback, itemErrorCallback;

  var $body;

  init = function (options) {
    settings = {
      productContainer: '[data-ajaxcart-product]',
      addToCartSelector: '[data-gwp-add-to-cart]',
      gwpContainer: '[data-ajax-gwp-items]',
      cartAddItem: '[data-cart-add]'
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // General Selectors
    $body = $(document.body);

    formOverride();

    // Track activity status
    isUpdating = false;
  };

  loadProducts = function () {      
    buildCollection(bb.AjaxcartGwp);
  };

  buildCollection = function (gwpData) {
    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $('#GwpTemplate').html(),
      template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(gwpData.products, function (index, collectionItem) {
      if (collectionItem.featured_image != null) {
        var prodImg = collectionItem.featured_image
          .replace(/(\.[^.]*)$/, '_150x$1')
          .replace('http:', '');
      } else {
        var prodImg =
          '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      }

      // Create item's data object and add to 'items' array
      item = {
        url: '/products/' + collectionItem.handle,
        img: prodImg,
        name: collectionItem.title,
        available: collectionItem.available,
        variant_id: collectionItem.variants[0].id,
        linePrice: slate.Currency.formatMoney(
          collectionItem.price,
          settings.moneyFormat
        )
      };

      items.push(item);
    });

    data = {
      title: gwpData.title,
      caption: gwpData.caption,
      disclaimer: gwpData.disclaimer,
      items: items
    };

    $(settings.gwpContainer).append(template(data));
    theme.SplideSlider.loadCartGwpSlider();
  };

  formOverride = function () {
    $body.on('click', settings.cartAddItem, function (evt) {
      evt.preventDefault();

      var $el = $(this);

      CartAPI.addItem(
        '/cart/add.js',
        $el.attr('data-cart-add'),
        itemAddedCallback,
        itemErrorCallback
      );
    });
  };

  itemAddedCallback = function () {
    ajaxCart.load();
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
  };

  module = {
    init: init,
    load: loadProducts
  };

  return module;
})(ajaxCart || {}, jQuery);



